/**
 * Brinde Charm (ATD-80) — interação do seletor de charm no cart drawer.
 *
 * Usa event delegation no document (não custom element) porque o drawer é
 * re-renderizado via Section Rendering API (innerHTML), e <script> injetado
 * por innerHTML não executa. Delegation sobrevive a qualquer re-render.
 */
(function () {
  if (window.__charmGiftReady) return;
  window.__charmGiftReady = true;

  var busy = false;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function post(path, payload) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );
  }

  document.addEventListener('click', function (event) {
    var addBtn = event.target.closest && event.target.closest('[data-charm-add]');
    var removeBtn = event.target.closest && event.target.closest('[data-charm-remove]');
    if (!addBtn && !removeBtn) return;

    event.preventDefault();
    if (busy) return;
    busy = true;

    var box = (addBtn || removeBtn).closest('charm-gift');
    if (box) box.setAttribute('aria-busy', 'true');

    var request = addBtn
      ? post('cart/add.js', {
          id: parseInt(addBtn.getAttribute('data-charm-add'), 10),
          quantity: 1,
          properties: { _brinde: 'Sim' }
        })
      : post('cart/change.js', {
          id: removeBtn.getAttribute('data-charm-remove'),
          quantity: 0
        });

    request
      .catch(function () {})
      .then(function () {
        busy = false;
        refreshCart();
      });
  });

  // Produto gatilho saiu do carrinho → remove o brinde órfão automaticamente.
  function sweepOrphan() {
    var orphan = document.querySelector('charm-gift[data-orphan-key]');
    if (!orphan || orphan.getAttribute('data-charm-swept')) return;
    orphan.setAttribute('data-charm-swept', '1');
    post('cart/change.js', {
      id: orphan.getAttribute('data-orphan-key'),
      quantity: 0
    })
      .catch(function () {})
      .then(refreshCart);
  }

  if (document.readyState !== 'loading') sweepOrphan();
  document.addEventListener('DOMContentLoaded', sweepOrphan);
  document.addEventListener('cart:change', sweepOrphan);
  document.addEventListener('cart:refresh', function () {
    setTimeout(sweepOrphan, 350);
  });
})();
